module.exports = __webpack_public_path__ + "assets/img/cap_blue.svg";